import { FileExplorerViewMode } from "../components/view-toggle";

const FOLDER_VIEW_MODE_KEY = "file-explorer-folder-view-mode";
const FILE_VIEW_MODE_KEY = "file-explorer-file-view-mode";

const isViewMode = (value: string | null): value is FileExplorerViewMode =>
  value === "list" || value === "icons";

export const getStoredFolderViewMode = (): FileExplorerViewMode => {
  const stored = localStorage.getItem(FOLDER_VIEW_MODE_KEY);
  return isViewMode(stored) ? stored : "list";
};

export const setStoredFolderViewMode = (mode: FileExplorerViewMode): void => {
  localStorage.setItem(FOLDER_VIEW_MODE_KEY, mode);
};

export const getStoredFileViewMode = (): FileExplorerViewMode => {
  const stored = localStorage.getItem(FILE_VIEW_MODE_KEY);
  return isViewMode(stored) ? stored : "list";
};

export const setStoredFileViewMode = (mode: FileExplorerViewMode): void => {
  localStorage.setItem(FILE_VIEW_MODE_KEY, mode);
};
